import * as React from 'react';
import styles from './AuthLayout.module.css';

interface AuthLayoutProps {
  children: React.ReactNode;
  quote: {
    text: string;
    name: string;
  };
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ quote, children }) => (
  <>
    <nav className={styles.Navbar}>
      <img
        src="/assets/white-logo.svg"
        className={styles.Brand}
      />
    </nav>
    <div className={styles.OauthLayout}>
      <div className={styles.Banner}>
        <div className={styles.BannerOverlay}>
          <div className={styles.BannerContent}>
            <p className={styles.Quote}>“ {quote.text}”</p>
            <span className={styles.Name}>- {quote.name}</span>
          </div>
        </div>
      </div>
      <div className={styles.Content}>
        <div>{children}</div>
      </div>
    </div>
  </>
);

export default AuthLayout;
